import { RestProvider, RestService } from '../rest/rest.service';
import { Models } from '@ibexfusion/models';
import { RestfulService } from '../rest/restful';
import { Injectable } from '@angular/core';

@Injectable()
export class DriverRouteService extends RestfulService<Models.DriverRouteModel> {

  constructor(public restService: RestService) {
    super(Models.DriverRouteModel);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('driver-route-models');
  }
}
